import { useEffect } from "react";
import { FaArrowRight } from 'react-icons/fa'
import M from 'materialize-css/dist/js/materialize.min';
import books from '../assets/books.jpg';
import globe from '../assets/globe.jpg';
import { motion } from 'framer-motion';

const Slider = () => {

    useEffect(() => {
        var elems = document.querySelectorAll('.slider');
        M.Slider.init(elems, {
            height: 460,
            indicators: false
        });

    }, []);

    return ( 
        <div className="slider">
            <ul className="slides">
                <li>
                    <img src={globe} alt="boooks" /> 
                    <div className="caption center-align"> 
                        <h3 className="super-bold mt-6 is-size-3-mobile is-size-2-tablet grey-text text-lighten-2">A Premier Polytechnic!</h3>
                        <div className="container">
                        <h5 className="light grey-text text-lighten-3 mb-5 is-size-6-touch is-size-5-desktop">We offer a wide variety of globally recognised certifications.</h5>
                        </div>
                        <motion.button 
                            className="button is-rounded main-color mb-6 border-none"
                            whileHover={{ scale: 1.1, originX: 'center'}}
                            transition={{ type: 'spring', stiffness: 600, damping: 3}}
                        >
                            <span className="icon">
                                <FaArrowRight color="white"/>
                            </span>
                            <a href="/#division-home" className="has-text-weight-normal white-text">Find Your Course</a>
                        </motion.button>
                    </div>
                </li>
                <li>
                    <img src={books} alt="Globe" /> 
                    <div className="caption left-align">
                    <h3>'Learning by Doing'</h3>
                    <h5 className="light is-size-6 grey-text text-lighten-3">Registered with the Ministry of Higher And Tertiary Education,<br/> Science and Technology Development </h5>
                    </div>
                </li>
            </ul>
        </div>
     );
}
 
export default Slider;